import { Modal, Button } from "react-bootstrap";
import React from "react";
import trash from "../../Assets/Images/trash.png";

//css
import "./Modal.css";

function DeleteModal(props) {
  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="row">
            <div className="col-12 align-wb-center">
              <img alt='img' src={trash} width={50} height={50} />
            </div>
            <div className="col-12 align-wb-center">
              {props.title || `Do you want to delete this customer?`}
            </div>

            <div className="col-12 align-wb-center font-xsmall">
              {props.hideUndoText ? "" : "This action can't be undone."}
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-sm-6">
              <Button
                size="sm"
                className="delete-btn"
                style={{ width: "100%" }}
                onClick={props.onDelete}
                disabled={props.isClicked}
              >
                {props.isClicked ? `Processing...` : (props.deleteLabel || `Delete`)}
              </Button>
            </div>
            <div className="col-sm-6">
              <Button
                size="sm"
                className="primary-btn"
                style={{ width: "100%" }}
                onClick={props.onHide}
                disabled={props.isClicked}
              >
                {props.closeLabel || `Cancel`}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default DeleteModal;
